import {
  DataTablePrimeReact,
  OverlayPanelRef,
  PaginationERP,
  SelectColumnsERP,
  TableERP,
} from "@finanedi.es/storybook"
import { faColumns } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  AsientosContablesQueryParamsPropsNew,
  LineaAsientosContableCall,
  getAsientoContableExportarExcel,
  getLineaAsientosContable,
  postCierreEjercicio,
} from "api/AsientoContable.service"
import { useCuentaContableEmpresaAll } from "api/CuentaContableEmpresa.hook"
import { useCuentaContableCuentaAll } from "api/CuentaContable_Cuenta.hook"
import { FacturaReadingSimpleDtoProps } from "api/DTOs/FacturaReadingSimpleDto"
import { LineasAsientosContablesByFilterDtoIProps } from "api/DTOs/LineasAsientosContablesByFilterDto"
import { getFacturasByIdSimple } from "api/Factura.service"
import { TIPO_DOCUMENTO_ENUM } from "api/Types/TipoDocumentoEnum"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import ModalCierreContable from "common/components/ModalCierreContable/ModalCierreContable"
import { ModalLoading } from "common/components/ModalLoading/ModalLoading"
import ModalVerDocumento from "common/components/ModalVerDocumento/ModalVerDocumento"
import { handleDirectDownloadExcel } from "common/context/DownloadFileProvider"
import { DATE_YYYY_MM_DD } from "constants/formatoFechas"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { format } from "date-fns"
import ModalAsientoContable from "features/Contabilidad/components/ModalAsientoContable/ModalAsientoContable"
import { useFilterMenu } from "hooks/useFilterMenu"
import { DataTableRowClickEventParams } from "primereact/datatable"
import { OverlayPanelEventType } from "primereact/overlaypanel"
import { useCallback, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  TIPO_ASIENTO_LABELS,
  TipoAsientoLabelsProps,
} from "../LibroMayor/constants/TipoAsientoLabels"
import { FilterMenu } from "./FilterMenu"
import { ModalCierreEjercicio } from "./components/Modales/ModalCierreEjercicio"
import { ModalConfirmacionCierre } from "./components/Modales/ModalConfirmacionCierre"
import {
  DateRangeModalFechas,
  ModalFechas,
} from "./components/Modales/ModalFechas"
import { LIBRO_DIARIO_COLUMNS } from "./constants/LibroDiarioColumns"
import "./styles.scss"

const LibroDiario = () => {
  const { t } = useTranslation()
  const [showModalAsiento, setShowModalAsiento] = useState(false)
  const [showExportDatesModal, setShowExportDatesModal] = useState(false)
  const [showModalCierreContable, setShowModalCierreContable] = useState(false)
  const currentYear = new Date().getFullYear()
  const fechaLowerLimit = new Date(currentYear, 0, 1, 0, 0, 0, 0)
  const fechaUpperLimit = new Date(currentYear, 11, 31, 23, 59, 59, 999)
  const DEFAULT_DATE = {
    min: fechaLowerLimit,
    max: fechaUpperLimit,
  }
  const [sortingCriteria, setSortingCriteria] = useState<SortingCriteria>({
    sort: undefined,
    property: undefined,
  })
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)

  const dtRef = useRef<DataTablePrimeReact<
    LineasAsientosContablesByFilterDtoIProps[]
  > | null>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }
  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
    handleResetPagination()
  }
  const [date, setDate] = useState<DateRangeModalFechas>(DEFAULT_DATE)
  const [keyword, setKeyword] = useState<string | undefined>()
  const [selectedAsientoTipo, setSelectedAsientoTipo] =
    useState<TipoAsientoLabelsProps>(TIPO_ASIENTO_LABELS(t)[0])
  const [amount, setAmount] = useState<{
    min: number | undefined
    max: number | undefined
  }>({
    min: undefined,
    max: undefined,
  })
  const [modalDocumentoDetail, setModalDocumentoDetail] = useState<{
    show: boolean
    document: FacturaReadingSimpleDtoProps | null
  }>({
    show: false,
    document: null,
  })

  const [asientoSelectedEdit, setAsientoSelectedEdit] = useState<string>()
  const [showModalClosingDates, setShowModalClosingDates] = useState(false)
  const [showModalClosingDatesSuccess, setShowModalClosingDatesSuccess] =
    useState(false)
  const [showModalClosingDatesLoading, setShowModalClosingDatesLoading] =
    useState(false)

  const fetchLibroDiario = useCallback(
    () => (queryParams: AsientosContablesQueryParamsPropsNew) => {
      LineaAsientosContableCall?.cancel()
      return getLineaAsientosContable({
        ...queryParams,
        SortingCriteria: queryParams.SortingCriteria,
      })
    },
    []
  )

  const { items, isLoading, totalCount, setServiceQuery, fetchTableData } =
    useFilterMenu({
      serviceCall: fetchLibroDiario,
    })

  const handleOpenModalAsientoContable = (data: $TSMigrationFixMe) => {
    if (data.asientoContable) {
      setShowModalAsiento(true)
      setAsientoSelectedEdit(data.asientoContable.id)
    }
  }

  const exportToExcel = async () => {
    const { data } = await getAsientoContableExportarExcel({
      // @ts-expect-error TS(2345): Argument of type '{ FechaLowerLimit: string; Fecha...
      FechaLowerLimit: date?.min ? format(date.min, DATE_YYYY_MM_DD) : "",
      FechaUpperLimit: date?.max ? format(date.max, DATE_YYYY_MM_DD) : "",
    })
    handleDirectDownloadExcel(data, `${t("exportarXlxs.libroDiario")}.xlsx`)
    setDate(DEFAULT_DATE)
  }

  const handlePostFinantialClosingDates = async (
    finantialClosingDates: $TSMigrationFixMe
  ) => {
    setShowModalClosingDates(false)
    setShowModalClosingDatesLoading(true)
    const finantialClosingDatesFormat = {
      fechaInicio: format(finantialClosingDates[0], DATE_YYYY_MM_DD),
      fechaFin: format(finantialClosingDates[1], DATE_YYYY_MM_DD),
    }
    try {
      const resp = await postCierreEjercicio(finantialClosingDatesFormat)
      if (resp.status === 200) {
        setShowModalClosingDatesLoading(false)
        setShowModalClosingDatesSuccess(true)
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
      setShowModalClosingDatesLoading(false)
    }
  }

  useCuentaContableCuentaAll()
  useCuentaContableEmpresaAll()

  const handleOpenDocumentoModal = async (id: string) => {
    const facturaById = await getFacturasByIdSimple(id)
    setModalDocumentoDetail({
      show: true,
      document: facturaById,
    })
  }
  const onRowClick = async ({
    data,
    originalEvent: { target },
  }: DataTableRowClickEventParams) => {
    const cell = target as HTMLTableCellElement
    if (!data.id || !cell?.cellIndex) return

    handleOpenModalAsientoContable(data)
  }

  const overlayRef = useRef<OverlayPanelRef>(null)
  const multiselectRef = useRef(null)
  const toggleOverlay = (
    event: OverlayPanelEventType,
    target?: HTMLElement
  ) => {
    overlayRef.current?.toggle(event, target)
  }

  const headerTemplate = () => {
    return (
      <div
        className='tw-cursor-pointer'
        onClick={toggleOverlay}
      >
        <FontAwesomeIcon
          size='xl'
          icon={faColumns}
        />
      </div>
    )
  }

  const columns = LIBRO_DIARIO_COLUMNS(
    t,
    handleOpenDocumentoModal,
    headerTemplate
  )

  const selectableColumns = columns.filter((col) => !col.isFixedColumn)

  const [visibleFields, setVisibleFields] = useState<string[]>(() =>
    selectableColumns
      .filter(
        (col) =>
          col.field !== "asientoContable.creationUser.nombre" &&
          col.field !== "asientoContable.creationTime"
      )
      .map((col) => col.field)
  )

  const visibleColumns = useMemo(
    () =>
      columns.filter(
        (col) => col.isFixedColumn || visibleFields.includes(col.field)
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visibleFields]
  )

  return (
    <section className='tw-flex tw-flex-col tw-order-2 tw-z-10 tw-relative tw-w-full tw-max-h-screen tw-h-full tw-max-w-screen tw-bg-gray tw-overflow-x-hidden tw-overflow-y-hidden'>
      <div className='tw-flex-none tw-bg-white tw-shadow-md'>
        <FilterMenu
          maxResultCount={pagination.itemsPerPage}
          resetPagination={handleResetPagination}
          serviceQuery={setServiceQuery}
          skipCount={pagination.skipCount}
          sortingCriteria={sortingCriteria}
          createAsiento={() => {
            setAsientoSelectedEdit(undefined)
            setShowModalAsiento(true)
          }}
          exportToExcel={() => setShowExportDatesModal(true)}
          setShowModalClosingDates={setShowModalClosingDates}
          setShowModalCierreContable={setShowModalCierreContable}
          selectedAsientoTipo={selectedAsientoTipo}
          setSelectedAsientoTipo={setSelectedAsientoTipo}
          keyword={keyword}
          setKeyword={setKeyword}
          amount={amount}
          setAmount={setAmount}
        />
      </div>
      <div className='tw-flex tw-flex-col tw-h-[calc(100%-140px)] tw-relative '>
        <div className='tw-h-full tw-min-h-0'>
          <SelectColumnsERP
            selectableColumns={selectableColumns}
            overlayRef={overlayRef}
            multiselectRef={multiselectRef}
            visibleFields={visibleFields}
            setVisibleFields={setVisibleFields}
            panelPosition='!-tw-top-9 !-tw-left-48'
          />
          <TableERP
            id='libro-diario-table'
            refTable={dtRef}
            columns={visibleColumns}
            className='tw-h-full !tw-z-0 !tw-min-w-full'
            scrollHeight='calc(100dvh - 210px)'
            columnResizeMode='expand'
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            removableSort
            value={items}
            showGridlines
            lazy
            dataKey='id'
            scrollable
            size='small'
            onRowClick={onRowClick}
            loading={isLoading}
            emptyMessage={t("primeReact.table.emptyMessage")}
          />
          <PaginationERP
            className={PAGINATION_STYLES}
            totalRecords={totalCount}
            first={pagination.skipCount}
            rows={pagination.itemsPerPage}
            resetScroll={() => {
              dtRef.current && dtRef.current?.resetScroll()
            }}
            setPagination={setPagination}
            optionDropdown={[10, 20, 50, 100]}
            texts={{
              textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
              textCurrentPageReport: `${t("pagination.from")}`,
            }}
          />
        </div>
      </div>

      <ModalAsientoContable
        idToEdit={asientoSelectedEdit}
        show={showModalAsiento}
        setShow={setShowModalAsiento}
        updateTable={fetchTableData}
      />

      <ModalCierreEjercicio
        isOpen={showModalClosingDates}
        close={() => setShowModalClosingDates(false)}
        handlePostFinantialClosingDates={handlePostFinantialClosingDates}
      />

      <ModalLoading
        isOpen={showModalClosingDatesLoading}
        title={t("mayor.modal.loadingTitle")}
      />

      <ModalConfirmacionCierre
        isOpen={showModalClosingDatesSuccess}
        close={() => {
          setShowModalClosingDatesSuccess(false)
          fetchTableData()
        }}
      />

      <ModalVerDocumento
        showModal={modalDocumentoDetail.show}
        onHide={() =>
          setModalDocumentoDetail({
            show: false,
            document: null,
          })
        }
        docType={TIPO_DOCUMENTO_ENUM.FACTURA}
        documentoID={modalDocumentoDetail.document?.id ?? null}
        typeDocumentTable='facturas'
      />
      <ModalFechas
        isOpen={showExportDatesModal}
        date={date}
        setDate={setDate}
        onCancel={() => setShowExportDatesModal(false)}
        onConfirm={exportToExcel}
        text={`${t("diario.exportModal.dateRange")}`}
      />
      <ModalCierreContable
        showModalCierreContable={showModalCierreContable}
        onCancel={() => setShowModalCierreContable(false)}
      />
    </section>
  )
}

export default LibroDiario
